(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_layered-slide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    if (typeof Shopify !== 'undefined' && Shopify.designMode) return;

    const slide = event.target.closest('[data-slide-link]');

    if (!slide) return;

    // Let the existing button/link work normally.
    if (
      event.target.closest('a, button, input, select, textarea, video, [role="button"]')
    ) {
      return;
    }

    const link = slide.dataset.slideLink;

    if (link) {
      window.location.href = link;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    if (typeof Shopify !== 'undefined' && Shopify.designMode) return;

    const slideContent = event.target.closest('[data-slide-link]');

    if (!slideContent) return;

    if (
      event.target.closest('a, button, input, select, textarea, video, [role="button"]')
    ) {
      return;
    }

    const link = slideContent.dataset.slideLink;

    if (link) {
      window.location.href = link;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
